import React from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CustomFieldsForm from "go-app/components/CustomFields/CustomFieldsForm";
import { mapToBase } from "go-core/api/searchSelectService";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { CustomValidationError } from "go-form/services/types";
import { CustomFieldTemplateApi } from "go-segment/services/types";
import { adminApi } from "../../../../../../services/Api/Admin/adminApi";
import { OrganizationApi, OrganizationFormProps } from "../../../../../../services/Api/types";

interface Props {
	form: UseFormReturn<OrganizationFormProps>;
	isPartner?: boolean;
	canEdit: (dataType?: "organization" | "company" | "contact") => boolean | undefined;
	customFieldsConfig: CustomFieldTemplateApi[];
	organization: OrganizationApi;
	setErrors: React.Dispatch<React.SetStateAction<CustomValidationError<OrganizationFormProps>[]>>;
}

const OrganizationAdminOtherInfoForm = ({
	form,
	isPartner,
	canEdit,
	customFieldsConfig,
	organization,
	setErrors,
}: Props) => {
	const { t } = useTranslation("admin");
	const {
		control,
		watch,
		formState: { errors },
		setValue,
		getValues,
	} = form;

	const handleChangeTags = (tags: string[]) => {
		setValue("tags", tags);
	};
	const handleCreateTag = (tag: string) => {
		setValue("tags", [...getValues().tags, tag], { shouldDirty: true });
	};

	const searchTags = async (search: string) => {
		const filter = mapToBase(search, { resource_type: "ORGANIZATION" });
		const res = await adminApi.getTagsListSearchSelect(filter);
		return res.map((value) => ({
			label: value.label,
			value: value.label,
		}));
	};

	const mapTags = (tags: string[]) => {
		return tags?.map((tag) => {
			return {
				value: tag,
				label: tag,
			};
		});
	};

	return (
		<div className="other-box">
			<h5 className="mt-4">{t("modules.organization.field.other.title")}</h5>
			{!isPartner && (
				<FormSelectGroup
					control={control}
					onCreateOption={handleCreateTag}
					isMulti
					onChange={handleChangeTags}
					loadOptions={searchTags}
					defaultValue={mapTags(watch("tags"))}
					errors={errors}
					name="tags"
					disabled={!canEdit()}
					getOptionValue={(opt) => opt.value}
					getOptionLabel={(opt) => opt.label}
					label={t("common.word.tags")}
					data-testid="tags"
				/>
			)}
			<CustomFieldsForm
				form={form}
				customFieldsConfig={customFieldsConfig}
				customFields={organization.custom_fields}
				setErrors={setErrors}
			/>
		</div>
	);
};

export default OrganizationAdminOtherInfoForm;
